import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  overflow: hidden;
  align-items: ${({ $align }) => $align};
  gap: var(--space-300);

  ${({ $color }) => $color &&
    css `
      color: ${$color};
    `}

  ${({ $hoverable }) => $hoverable &&
    css `
      position: relative;
      z-index: 0;
    `};
`;
export const NameContainer = styled.div `
  max-width: calc(100% - 38px); // 26px logo width + margin

  ${({ $withoutLogo }) => $withoutLogo &&
    css `
      max-width: 100%;
    `}

  color: var(--text-primary);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400);
`;
export const Name = styled.div `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const ImageContainer = styled.div `
  padding-left: var(--space-350);
  border-left: 1px solid var(--border-primary);
`;
export const Image = styled.img `
  height: var(--space-500);
  max-width: 300px;

  object-fit: contain;
`;
export const Append = styled.div `
  align-self: center;
`;
//# sourceMappingURL=Dashboard.styled.js.map